import {
  Usuario,
  UsuarioFilters,
  PaginatedUsuarioResponse,
} from "../types/usuario";
import { UsuarioFormData, UsuarioUpdateData } from "../lib/validations";
import { apiClient } from "./apiClient";

export const usuarioService = {
  getUsuarios: async (
    filters?: UsuarioFilters
  ): Promise<PaginatedUsuarioResponse> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "")
          params.append(key, value.toString());
      });
    }
    if (!params.has("page")) params.set("page", "1");
    if (!params.has("limit")) params.set("limit", "10");
    const url = `/usuarios?${params.toString()}`;
    return apiClient.get(url);
  },

  getUsuarioById: async (id: number): Promise<Usuario> => {
    return apiClient.get(`/usuarios/${id}`);
  },

  createUsuario: async (data: UsuarioFormData): Promise<Usuario> => {
    return apiClient.post("/usuarios", data);
  },

  updateUsuario: async (
    id: number,
    data: UsuarioFormData | UsuarioUpdateData
  ): Promise<Usuario> => {
    return apiClient.put(`/usuarios/${id}`, data);
  },

  deleteUsuario: async (id: number): Promise<void> => {
    return apiClient.delete(`/usuarios/${id}`);
  },
};
